export enum EntityViewColumnFormat {
    default = 0,
    currency = 1
}